const _store = {
    topics: {}
};

const _getSubscribes = (topic = '') => {
    const subscribers = _store.topics[topic] || [];

    if (!Array.isArray(subscribers)) {
        return [];
    }

    return subscribers;
};

const _addTopic = (topic, subscriber) => {
    const subscribers = _getSubscribes(topic);

    _store.topics[topic] = [].concat(subscribers, subscriber);
};

export const subscribeTopic = (topic, subscriber) => {
    const subscribers = _getSubscribes(topic);

    if (subscribers.indexOf(subscriber) !== -1) {
        return false;
    }

    if (typeof subscriber !== "function") {
        return false;
    }

    _addTopic(topic, subscriber);

    return true;
};

export const unsubscribeTopic = (topic, subscriber) => {
    const subscribers = _getSubscribes(topic);
    _store.topics[topic] = subscribers.filter(_subscriber => _subscriber !== subscriber);

    return true;
};

export const broadcastTopic = (topic, payload = null) => {
    const subscribers = _getSubscribes(topic);

    console.log(topic);
    console.log(payload);
    console.log(subscribers);

    subscribers.forEach(subscriber => {
        typeof subscriber === 'function' && subscriber(payload);
    });
};


// WEBPACK FOOTER //
// ./src/services/EventServices.js